import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import packageJson from '../../../../package.json';

interface FooterProps {
  ref?: React.Ref<HTMLDivElement>;
}

const Footer: FC<FooterProps> = ({ ref }) => {
  const { t } = useTranslation();
  const betaRunNumber = import.meta.env.VITE_APP_RUN_NUMBER;
  const currentEnv = import.meta.env.MODE;

  return (
    <footer
      ref={ref}
      className="fixed bottom-0 left-0 footer footer-center px-4 py-3 bg-linear-to-t from-base-100 to-transparent backdrop-blur-lg text-base-content/60 z-10"
    >
      <aside className="flex gap-3 text-xs">
        <div>
          Copyright © {new Date().getFullYear()} - All rights reserved by{' '}
          <span className="text-primary">{t('settings.app.name')}</span>
        </div>
        <div>
          {currentEnv === 'development' && (
            <span className="badge badge-xs badge-primary">Development Build</span>
          )}
          {currentEnv === 'staging' && betaRunNumber && (
            <span className="badge badge-xs badge-primary">{`v ${packageJson.version}.${betaRunNumber}-Beta`}</span>
          )}
          {currentEnv === 'production' && (
            <span className="badge badge-xs badge-primary"> v{packageJson.version}</span>
          )}
        </div>
      </aside>
    </footer>
  );
};

export default Footer;
